import * as $gzFields from './fields.service';

export default angular.module('gazelle.components.fields', [
  'pascalprecht.translate',
  'angularMoment',
  'ngSanitize',
])
  .service($gzFields.name, $gzFields.default)
  .name;




// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/fields/fields.module.js